<script lang="ts">
import { lateinit } from 'tg-commons'
import { ControlPosition, unwrapStringEnumValue, type BaseMap, type StreetViewControl, type StreetViewControlOptions, type WrapStringEnumValue } from 'tg-map-core'
import { defineComponent, watch } from 'vue'
import { createEmptyVNode, stringEnumProp, type Props } from '../../utils/vue-utils'
import { useTgMapInner } from '../map-hooks'
/**
 * 街景控件, 当前只有google支持
 * */
export default defineComponent({
  name: 'tg-street-view-control',
  props: {
    position: stringEnumProp(ControlPosition, ControlPosition.RIGHT_BOTTOM),
  } satisfies Props<WrapStringEnumValue<StreetViewControlOptions, {
    position: typeof ControlPosition,
  }>>,
  setup(props) {
    let control = lateinit<StreetViewControl>()

    const { map, onCreate, onDestroy } = useTgMapInner<BaseMap>()

    onCreate(() => {
      control = map.createStreetViewControl(unwrapStringEnumValue(props))
      map.addControl(control)
    })

    onDestroy(() => {
      map.removeControl(control)
    })

    watch(() => props.position, (value) => {
      control.setPosition(unwrapStringEnumValue(value, ControlPosition))
    })
    return createEmptyVNode
  },
})
</script>
